// LeftBar 的 ref="LeftBar_c" 挂在 App.vue 实例上，不是 Vue 的 this.$root——
// qiankun 场景下 $root 是不持有该 ref 的外壳实例，直接用 this.$root.$refs.LeftBar_c
// 永远拿不到 LeftBar，只能沿 $parent 链往上找到真正持有这个 ref 的组件实例。
export function findLeftBarRef(vm) {
  let cur = vm && vm.$parent;
  while (cur) {
    if (cur.$refs && cur.$refs.LeftBar_c) return cur.$refs.LeftBar_c;
    cur = cur.$parent;
  }
  return null;
}
